import type { GetServerSideProps } from "next";

export default function CommunityRedirect() {
  return null;
}

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    redirect: {
      destination: "/community",
      permanent: true,
    },
  };
};
